import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import { SHORT_CAROUSEL_ASPECT_RATIO, TALL_CAROUSEL_ASPECT_RATIO } from '../constants';
import LazyLoadAspectRatioCardImage from './LazyLoadAspectRatioCardImage';

import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import './CarouselCard.less';

// This is due to react-hot-loader creating a proxied version of a component
const LazyImageType = (<LazyLoadAspectRatioCardImage imageUri="" aspectRatio={SHORT_CAROUSEL_ASPECT_RATIO}/>).type;

const CarouselCard = ({
  /** Url where the user will navigate to when clicking on the card */
  clickUrl,
  /** Native target attribute for links */
  target,
  /** Callback to be called when the user clicks on the card */
  onClick,
  /** Value to determine whether to use a short or a tall card */
  aspectRatio,
  /** Class to be added to the card anchor */
  className,
  /** Rel attribute to specify the relationship between the homepage and the external links */
  relUrl,
  children,
  ...otherProps
}) => {
  const clonedChildren = React.Children.map(children, child => (child.type === LazyImageType) ?
    React.cloneElement(child, { aspectRatio }) :
    child
  );

  return (
    <a
      href={clickUrl}
      target={target}
      className={cnames('CarouselCard', { [className]: className })}
      onClick={onClick}
      rel={relUrl}
    >
      <AspectRatioCard
        aspectRatio={aspectRatio}
        {...otherProps}
      >
        {clonedChildren}
      </AspectRatioCard>
    </a>
  );
};

CarouselCard.propTypes = {
  onClick: PropTypes.func,
  clickUrl: PropTypes.string.isRequired,
  aspectRatio: PropTypes.oneOf([TALL_CAROUSEL_ASPECT_RATIO, SHORT_CAROUSEL_ASPECT_RATIO]),
  className: PropTypes.string,
  relUrl: PropTypes.string
};

CarouselCard.defaultProps = {
  onClick: () => {},
  className: '',
  target: '_self',
  aspectRatio: SHORT_CAROUSEL_ASPECT_RATIO
};

export default CarouselCard;
